export default __webpack_public_path__ + "static/mainLogo-ef0b62042728f499a3ea63d8a3c70aa0.png";